import React from "react"; 
import "./products.css" 
import Header from "../../components/header/Header";

import ProductsBanner from "../../assets/images/products_banner.png"

const Products = () =>{
    return(
        <>
           
           <Header />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="products_banner">
                            <img src={ProductsBanner} alt="banner" className="img-fluid rounded" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-2 col-md-2 ">
                        <div className="products_banner">
                            1
                         </div>
                    </div>
                    <div className="col-lg-10 col-md-10 ">
                        <div className="products_banner">
                        3
                         </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Products;